import "./inputText.css";

function InputText({ textClass, textValue, handleName, setHandleName }) {
  return (
    <input
      type="text"
      className={textClass}
      placeholder={textValue}
      value={handleName}
      onChange={(e) => setHandleName(e.target.value)}
    />
  );
}

export default InputText;
